import { environment } from 'src/environments/environment';

export const loadPortalFeature = () =>
  environment.featureMode === 'anticipation-portal'
    ? import('./features/seller-anticipation-portal/seller-anticipation-portal.routes').then(
        (m) => m.SELLER_ANTICIPATION_PORTAL_ROUTES,
      )
    : Promise.reject(
        new Error(`Feature mode invalido: ${environment.featureMode}`),
      );
